import { GridColDef } from "@mui/x-data-grid";
import AedasLoading from "../../Components/Shared/AedasLoading/AedasLoading";
import { ListEditItems } from "../../Components/ListEditItems/ListEditItems";
import TableFilters from "../../Components/Shared/TableFilters/TableFilters";
import { useRowFilter } from "../../Components/Shared/TableFilters/useRowFilter";
import { actionsColumn } from "../../Components/Shared/TableActions/TableActions";

// Tabla de las pestañas Roles y Permisos: son listas cortas que el back no
// pagina ni filtra, así que se cargan enteras y el buscador filtra en el cliente
type SearchableTableProps = {
  rows: any[] | null;
  columns: GridColDef[]; // sin la columna de acciones, que se añade aquí
  loading: boolean;
  onEdit: (row: any) => void;
  onDelete: (row: any) => void;
  canEdit?: (row: any) => boolean;
  canDelete?: (row: any) => boolean;
};

export default function SearchableTable(props: SearchableTableProps) {
  const { rows, columns, loading, onEdit, onDelete, canEdit, canDelete } = props;
  const { filteredRows, filterProps } = useRowFilter(rows, columns);

  if (loading && !rows) {
    return <AedasLoading />;
  }

  return (
    <>
      <TableFilters {...filterProps} />
      <div className="entityPage__table">
        <ListEditItems
          rows={filteredRows}
          columns={[...columns, actionsColumn({ onEdit, onDelete, canEdit, canDelete })]}
          onRowClick={(row) => (!canEdit || canEdit(row) ? onEdit(row) : undefined)}
          fillHeight
        />
      </div>
    </>
  );
}
